/* Office Catch premium skin — vanilla JS, no dependencies.
   Finder (predictive search), bestseller tabs, quick add, scroll reveals. */
(function () {
  "use strict";

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return "$" + v.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  var escapeHtml = function (s) {
    return String(s || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  };
  var highlight = function (text, terms) {
    var out = escapeHtml(text);
    terms.forEach(function (t) {
      if (t.length < 2) return;
      var re = new RegExp("(" + t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
      out = out.replace(re, "<mark>$1</mark>");
    });
    return out;
  };

  /* ---------- Scroll reveals ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll(".oc-reveal:not(.oc-is-in), .oc-reveal-stagger:not(.oc-is-in)");
    if (designMode || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("oc-is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("oc-is-in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Bestseller tabs ---------- */
  function initTabs(section) {
    var tabs = section.querySelectorAll(".oc-tabs [role=tab]");
    var panels = section.querySelectorAll("[role=tabpanel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
        var target = document.getElementById(tab.dataset.panel);
        panels.forEach(function (p) {
          if (p === target) {
            p.hidden = false;
            p.classList.remove("oc-is-in");
            p.classList.add("oc-is-swapping");
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { p.classList.remove("oc-is-swapping"); p.classList.add("oc-is-in"); });
            });
          } else {
            p.hidden = true;
          }
        });
      });
    });
  }

  /* ---------- Quick add (AJAX cart) ---------- */
  function initQuickAdd(root) {
    (root || document).querySelectorAll("form[data-oc-quick-add]").forEach(function (form) {
      if (form.dataset.ocBound) return;
      form.dataset.ocBound = "1";
      form.addEventListener("submit", function (e) {
        if (!window.fetch) return; // native submit fallback
        e.preventDefault();
        var btn = form.querySelector(".oc-quick");
        var label = btn.textContent;
        btn.classList.add("oc-is-adding");
        btn.textContent = "Adding…";
        var fd = new FormData(form);
        fd.append("sections", "mini-cart,header");
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: fd
        }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function (item) {
            btn.classList.remove("oc-is-adding");
            btn.classList.add("oc-is-added");
            btn.textContent = "Added";
            // Warehouse theme listens for this event to refresh mini-cart / count.
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } }));
            document.documentElement.dispatchEvent(new CustomEvent("product:added", { bubbles: true, detail: { variant: item, quantity: 1 } }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
            setTimeout(function () { btn.classList.remove("oc-is-added"); btn.textContent = label; }, 1800);
          })
          .catch(function () {
            btn.classList.remove("oc-is-adding");
            btn.textContent = label;
            form.submit(); // fall back to full page add
          });
      });
    });
  }

  /* ---------- Model finder (Shopify predictive search) ---------- */
  function initFinder(finder) {
    var input = finder.querySelector("[data-oc-finder-input]");
    var results = finder.querySelector("[data-oc-finder-results]");
    var tabs = finder.querySelectorAll(".oc-finder-tabs [role=tab]");
    var chips = finder.querySelectorAll(".oc-finder-popular button");
    var limit = parseInt(finder.dataset.limit, 10) || 6;
    if (!input || !results) return;

    var prefix = "";
    var timer = null;
    var lastQ = "";
    var controller = null;

    function close() { results.classList.remove("oc-is-open"); results.innerHTML = ""; }

    function render(products, terms, q) {
      if (!products.length) {
        results.innerHTML = '<div class="oc-r-empty">No exact match yet for “' + escapeHtml(q) + '”. Try the code printed on your old cartridge or battery, or call <strong>1300 189 667</strong> and we\u2019ll find it for you.</div>';
      } else {
        results.innerHTML = products.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x120$1$2") : "";
          var meta = [p.vendor, p.type].filter(function (x) { return x && x !== "Office Catch"; }).join(" · ");
          return '<a href="' + escapeHtml(p.url) + '" role="option">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="52" height="52">' : '<span></span>') +
            '<span><span class="oc-r-name">' + highlight(p.title, terms) + '</span>' + (meta ? '<br><span class="oc-r-meta">' + escapeHtml(meta) + '</span>' : '') + '</span>' +
            '<span class="oc-r-price">' + (p.price ? money(parseFloat(p.price) * 100) : "") + '</span></a>';
        }).join("");
      }
      results.classList.add("oc-is-open");
    }

    function search(raw) {
      var q = (raw || "").trim();
      if (q.length < 2) { close(); return; }
      var full = (prefix ? prefix + " " : "") + q;
      if (full === lastQ && results.innerHTML) { results.classList.add("oc-is-open"); return; }
      lastQ = full;
      if (controller) controller.abort();
      controller = ("AbortController" in window) ? new AbortController() : null;
      var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/") + "search/suggest.json?q=" + encodeURIComponent(full) +
        "&resources[type]=product&resources[limit]=" + limit +
        "&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,tag,vendor";
      fetch(url, { signal: controller ? controller.signal : undefined, headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (full !== lastQ) return;
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          var terms = q.toLowerCase().split(/[^a-z0-9+&]+/).filter(Boolean);
          // Retry without prefix if the prefixed query found nothing.
          if (!products.length && prefix) {
            var url2 = url.replace("q=" + encodeURIComponent(full), "q=" + encodeURIComponent(q));
            return fetch(url2, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (d2) {
              if (full !== lastQ) return;
              var p2 = (d2 && d2.resources && d2.resources.results && d2.resources.results.products) || [];
              render(p2, terms, q);
            });
          }
          render(products, terms, q);
        })
        .catch(function (err) { if (err && err.name === "AbortError") return; close(); });
    }

    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(function () { search(input.value); }, 180);
    });
    input.addEventListener("focus", function () { if (input.value) search(input.value); });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { close(); }
      if (e.key === "ArrowDown") { var first = results.querySelector("a"); if (first) { e.preventDefault(); first.focus(); } }
    });
    results.addEventListener("keydown", function (e) {
      var items = Array.prototype.slice.call(results.querySelectorAll("a"));
      var i = items.indexOf(document.activeElement);
      if (e.key === "ArrowDown" && i < items.length - 1) { e.preventDefault(); items[i + 1].focus(); }
      if (e.key === "ArrowUp") { e.preventDefault(); if (i > 0) items[i - 1].focus(); else input.focus(); }
      if (e.key === "Escape") { close(); input.focus(); }
    });
    document.addEventListener("click", function (e) { if (!finder.contains(e.target)) results.classList.remove("oc-is-open"); });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
        prefix = tab.dataset.prefix || "";
        if (tab.dataset.placeholder) input.placeholder = tab.dataset.placeholder;
        lastQ = "";
        if (input.value) search(input.value);
        input.focus();
      });
    });

    chips.forEach(function (b) {
      b.addEventListener("click", function () {
        input.value = b.dataset.q || b.textContent.trim();
        var q = input.value.toLowerCase();
        var guess = null;
        tabs.forEach(function (t) {
          var label = (t.textContent || "").toLowerCase();
          if (/dyson|vacuum|sv\d/.test(q) && /vacuum|dyson/.test(label)) guess = t;
          else if (/remote|merlin|bn59|garage/.test(q) && /remote/.test(label)) guess = t;
          else if (/charger|macbook|thinkpad|usb-c/.test(q) && /charger/.test(label)) guess = t;
        });
        if (!guess && tabs.length) guess = tabs[0];
        if (guess) guess.click(); else search(input.value);
      });
    });
  }

  /* ---------- Boot ---------- */
  function boot(root) {
    initReveals(root);
    (root || document).querySelectorAll("[data-oc-tabs]").forEach(initTabs);
    (root || document).querySelectorAll("[data-oc-finder]").forEach(initFinder);
    initQuickAdd(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  // Theme editor: re-init when a section is (re)loaded.
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
